import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { usePage } from '../hooks/usePage';
import { useT } from '../i18n/useT';
import { useTracking } from '../hooks/useTracking';
export function ContentView({ config, pageKey }) {
    const { page, loading, error } = usePage(pageKey);
    useTracking({ module: 'content', pageKey, pageTitle: page?.title });
    const { t } = useT();
    return (_jsxs(_Fragment, { children: [_jsx(Header, { config: config }), _jsxs("main", { className: "container mx-auto px-4 pt-24 pb-8", children: [loading && _jsx("p", { className: "text-center py-8", "data-translate": "loading", children: t('loading', 'Betöltés...') }), error && _jsxs("p", { className: "text-center py-8 text-red-700", children: [_jsx("span", { "data-translate": "error_generic", children: t('error_generic', 'Hiba') }), ": ", error] }), page && (_jsx("article", { children: _jsx("div", { className: "prose", dangerouslySetInnerHTML: { __html: page.html } }) }))] }), _jsx(Footer, { config: config })] }));
}
